<template>
  <div id="app">
    <transition name="fade">
      <info-modal :dismissInSec="30" v-if="ui.showConfirmInfo" @close="ui.showConfirmInfo = false">
        <template v-slot:title>
          Bestätigung erfolgreich!
        </template>
        <template v-slot:text>
          Sie sind nun eingeloggt und können auf den Download-Bereich zugreifen sowie ihre Daten und App-Einstellungen anpassen.
        </template>
        <template v-slot:footer>
          Kennen Sie schon die neue ERGO BU? Die lohnt sich für Sie und Ihre jungen Kunden!
        </template>
      </info-modal>
    </transition>
    <router-view/>
  </div>
</template>

<script>
import infoModal from '@/components/infoModal.vue'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'App',
  components: {
    infoModal
  },
  data() {
    return {
      state: this.$store.state,
      ui: {
        showConfirmInfo: false
      }
    }
  },
  /*
  when App mounted:
  is confirmation query parameter present
  if yes:
    show confirm info
  login parameter and token parameter present
  if yes:
    set token in app and call login function#
  if not:
    check if token is in local storage
      if yes:
        set token in app and call login function
  */
  async mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.$store.trackingView("LandingPage");
      }
    }
    //makes route object available in store
    this.state.$route = this.$route
    console.log(this.$route, this.state.app)
    //check if "vertrieb" is in url. if yes, it's the vertrieb version with less content and the user should be flagged during registration
    if (window.location.pathname.includes('vertrieb')) {
      this.state.app.isVertrieb = true
      console.log("is vertrieb")
    } else {
      if (this.$route.query.fv) {
        window.location.href = window.location.origin + '/vertrieb/' + window.location.hash
        this.state.app.isVertrieb = true
      }
    }
    this.$store.state.emptyUserData = JSON.parse(JSON.stringify(this.$store.state.userData))
    let token = this.$ls.get('token')
    if (token) {
      this.state.app.token = token
      await this.$store.login()
    }
    else if (this.$route.query.login && this.$route.query.token) {
      this.state.app.token = this.$route.query.token
      await this.$store.login()
    }
    await this.$recaptchaLoaded()
    this.state.app.recaptchaLoaded = true
    if (this.$route.query.confirm) {
      this.handleConfirm()
    }
    if (this.$route.query.error) {
      await this.handleError(this.$route.query.error)
    }
    if (this.$route.query.login || this.$route.query.confirm || this.$route.query.error) this.$router.push(this.$route.path)
  },
  methods: {
    async handleError(error) {
      let text = error
      if (error == 'Login fehlgeschlagen') {
        text = 'Login fehlgeschlagen. Eventuell ist der Login-Link abgelaufen. Bitte fordern Sie einfach einen neuen Login-Link an.'
        //when this error occurs there should be a new login request fired without error message, but only if user is not logged in
        if (!this.$store.compIsLoggedIn) await this.$store.requestLoginToken()
        return
      }
      await this.$fire({
        title: 'Fehler!',
        text: text,
        type: "error"
      })
    },
    async handleConfirm() {
      //this.ui.showConfirmInfo = true
      let text
      let title
      if (this.$store.compHasCustomApp) {
        this.$store.trackingView("app_confirmed", "DoubleOptInApp");

        title = 'Ihre App wurde erstellt!'
        text = 'Wir haben Ihnen den Link für Ihre persönliche Akquise-App per E-Mail geschickt. Ab sofort können Sie auf dieser Seite Ihre Kontaktdaten ändern und auf die Downloads zugreifen.'
      } else {
        this.$store.trackingView("downloads_confirmed", "DoubleOptInDownload");

        title = 'Registrierung bestätigt!'
        text = 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt. Sie können nun auf den Downloadbereich zugreifen. Ihre persönliche Akquise-App können Sie natürlich jederzeit nachträglich erstellen.'
      }
      await this.$fire({
        title: title,
        text: text,
        type: "success"
      })
    },
    async getUserData() {

    },
    confirm() {

    }
  }
}
</script>

<style lang="stylus">
  @font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-Regular.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-Regular.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-Regular.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-Regular.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-Regular.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-Regular.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-Regular.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-Bold.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-Bold.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-Bold.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-Bold.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-Bold.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-Bold.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-Bold.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-Heavy.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-Heavy.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-Heavy.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-Heavy.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-Heavy.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-Heavy.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-Heavy.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-Light.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-Light.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-Light.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-Light.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-Light.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-Light.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-Light.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-Italic.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-Italic.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-Italic.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-Italic.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-Italic.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-Italic.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-Italic.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 400;
    font-style: italic;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-LightItalic.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-LightItalic.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-LightItalic.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-LightItalic.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-LightItalic.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-LightItalic.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-LightItalic.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 300;
    font-style: italic;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-BoldItalic.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-BoldItalic.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-BoldItalic.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-BoldItalic.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-BoldItalic.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-BoldItalic.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-BoldItalic.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 600;
    font-style: italic;
}

@font-face {
    font-family: "FSMePro";
    src: url("~@/assets/fonts/FSMePro-HeavyItalic.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FSMePro-HeavyItalic.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
        url("~@/assets/fonts/FSMePro-HeavyItalic.otf") format("opentype"), /* Open Type Font */
        url("~@/assets/fonts/FSMePro-HeavyItalic.svg") format("svg"), /* Legacy iOS */
        url("~@/assets/fonts/FSMePro-HeavyItalic.ttf") format("truetype"), /* Safari, Android, iOS */
        url("~@/assets/fonts/FSMePro-HeavyItalic.woff") format("woff"), /* Modern Browsers */
        url("~@/assets/fonts/FSMePro-HeavyItalic.woff2") format("woff2"); /* Modern Browsers */
    font-weight: 900;
    font-style: italic;
}



@font-face {
    font-family: "FedraSerifAPro";
    src: url("~@/assets/fonts/FedraSerifProABold.eot"); /* IE9 Compat Modes */
    src: url("~@/assets/fonts/FedraSerifProABold.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
      url("~@/assets/fonts/FedraSerifProABold.otf") format("opentype"), /* Open Type Font */
      url("~@/assets/fonts/FedraSerifProABold.svg") format("svg"), /* Legacy iOS */
      url("~@/assets/fonts/FedraSerifProABold.ttf") format("truetype"), /* Safari, Android, iOS */
      url("~@/assets/fonts/FedraSerifProABold.woff") format("woff"), /* Modern Browsers */
      url("~@/assets/fonts/FedraSerifProABold.woff2") format("woff2"); /* Modern Browsers */
    font-weight: bold;
    font-style: normal;
  }

.instagram-padding {
  padding:17%
}

strong {
  font-weight: 700!important;
}

.tooltip {
  background-color: #be1528!important;
  width:auto!important
  font-size:15px!important
  width:400px!important
  max-width:90vw!important
  .tooltip-inner {
    width:auto!important
    background: #be1528;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip.popover .popover-arrow {
    border-color: #be1528;
  }
}

.nomargin {
  margin:0px!important
}
.nopadding {
  padding:0px!important
}

//misplacement fix
.swal2-container {
  span {
    font-size: 1em
  }
}
.swal2-actions {
  .swal2-confirm {
    background-color: #be1528!important
    outline: none!important
  }
}

.input-error {
  margin-top:6px
  margin-left:3px
  color: #BF1528
}

  html body *{
    font-family "FSMePro",Verdana, Geneva, Tahoma, sans-serif
    font-weight normal
    font-style normal
  }

  #app {
    background-color: #393939
  }
  
  body {
    font-size 14px
    
    /* Small only */
    @media screen and (max-width: 39.9375em) {
      font-size 12px
    }

    /* Medium and up */
    @media screen and (min-width: 40em) {}

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {}

    /* Large and up */
    @media screen and (min-width: 64em) {}

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {}

    p, span, label {
      font-size 1.14em
      color #000
    }

    #app [type="radio"]:checked,
    #app [type="radio"]:not(:checked) {
        position: absolute;
        left: -9999px;
    }
    #app [type="radio"]:checked + label,
    #app [type="radio"]:not(:checked) + label
    {
        position: relative;
        padding-left: 2.5em;
        cursor: pointer;
        line-height: 1.5em;
        display: inline-block;
        color: #000;
    }
    #app [type="radio"]:checked + label:before,
    #app [type="radio"]:not(:checked) + label:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 1.5em;
        height: 1.5em;
        border: 1px solid #ddd;
        border-radius: 100%;
        background: #fff;
    }
    #app [type="radio"]:checked + label:after,
    #app [type="radio"]:not(:checked) + label:after {
        content: '';
        width: .88em;
        height: .88em;
        background: #BF1528;
        position: absolute;
        top: .35em;
        left: .35em;
        border-radius: 100%;
        transition: all 0.2s ease;
    }
    #app [type="radio"]:not(:checked) + label:after {
        opacity: 0;
        transform: scale(0);
    }
    #app [type="radio"]:checked + label:after {
        opacity: 1;
        transform: scale(1);
    }

    

    #app [type="checkbox"]:checked,
    #app [type="checkbox"]:not(:checked) {
        position: absolute;
        left: -9999px;
    }
    #app [type="checkbox"]:checked + label,
    #app [type="checkbox"]:not(:checked) + label
    {
        position: relative;
        padding-left: 2em;
        cursor: pointer;
        line-height: 1.5em;
        display: inline-block;
        color: #000;
        margin-bottom 1.2em
        margin-left 0
    }
    #app [type="checkbox"]:checked + label:before,
    #app [type="checkbox"]:not(:checked) + label:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 1.5em;
        height: 1.5em;
        border: 1px solid #ddd;
        border-radius: .2em;
        background: #fff;
    }
    #app [type="checkbox"]:checked + label:after,
    #app [type="checkbox"]:not(:checked) + label:after {
        content: '';
        width: .88em;
        height: .88em;
        background: #BF1528;
        position: absolute;
        top: .35em;
        left: .35em;
        border-radius: .2em;
        transition: all 0.2s ease;
    }
    #app [type="checkbox"]:not(:checked) + label:after {
        opacity: 0;
        transform: scale(0);
    }
    #app [type="checkbox"]:checked + label:after {
        opacity: 1;
        transform: scale(1);
    }
  }

.link {
  cursor:pointer
}

.p-0 {
  padding: 0px;
}

.p-3 {
  padding: 3px;
}

.p-5 {
  padding: 5px;
}

.p-10 {
  padding: 10px;
}

.p-15 {
  padding: 15px;
}

.p-20 {
  padding: 20px;
}

.p-25 {
  padding: 25px;
}

.p-30 {
  padding: 30px;
}

.p-35 {
  padding: 35px;
}

.p-40 {
  padding: 40px;
}

.p-45 {
  padding: 45px;
}

.p-50 {
  padding: 50px;
}

.pt-0 {
  padding-top: 0px;
}

.pt-3 {
  padding-top: 3px;
}

.pt-5 {
  padding-top: 5px;
}

.pt-10 {
  padding-top: 10px;
}

.pt-15 {
  padding-top: 15px;
}

.pt-20 {
  padding-top: 20px;
}

.pt-25 {
  padding-top: 25px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-35 {
  padding-top: 35px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-45 {
  padding-top: 45px;
}

.pt-50 {
  padding-top: 50px;
}

.pr-0 {
  padding-right: 0px;
}

.pr-3 {
  padding-right: 3px;
}

.pr-5 {
  padding-right: 5px;
}

.pr-10 {
  padding-right: 10px;
}

.pr-15 {
  padding-right: 15px;
}

.pr-20 {
  padding-right: 20px;
}

.pr-25 {
  padding-right: 25px;
}

.pr-30 {
  padding-right: 30px;
}

.pr-35 {
  padding-right: 35px;
}

.pr-40 {
  padding-right: 40px;
}

.pr-45 {
  padding-right: 45px;
}

.pr-50 {
  padding-right: 50px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pb-3 {
  padding-bottom: 3px;
}

.pb-5 {
  padding-bottom: 5px;
}

.pb-10 {
  padding-bottom: 10px;
}

.pb-15 {
  padding-bottom: 15px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pb-25 {
  padding-bottom: 25px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-35 {
  padding-bottom: 35px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pb-45 {
  padding-bottom: 45px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pl-0 {
  padding-left: 0px;
}

.pl-3 {
  padding-left: 3px;
}

.pl-5 {
  padding-left: 5px;
}

.pl-10 {
  padding-left: 10px;
}

.pl-15 {
  padding-left: 15px;
}

.pl-20 {
  padding-left: 20px;
}

.pl-25 {
  padding-left: 25px;
}

.pl-30 {
  padding-left: 30px;
}

.pl-35 {
  padding-left: 35px;
}

.pl-40 {
  padding-left: 40px;
}

.pl-45 {
  padding-left: 45px;
}

.pl-50 {
  padding-left: 50px;
}

.m-0 {
  margin: 0px;
}

.m-3 {
  margin: 3px;
}

.m-5 {
  margin: 5px;
}

.m-10 {
  margin: 10px;
}

.m-15 {
  margin: 15px;
}

.m-20 {
  margin: 20px;
}

.m-25 {
  margin: 25px;
}

.m-30 {
  margin: 30px;
}

.m-35 {
  margin: 35px;
}

.m-40 {
  margin: 40px;
}

.m-45 {
  margin: 45px;
}

.m-50 {
  margin: 50px;
}

.mt-0 {
  margin-top: 0px;
}

.mt-3 {
  margin-top: 3px;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-25 {
  margin-top: 25px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-35 {
  margin-top: 35px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-45 {
  margin-top: 45px;
}

.mt-50 {
  margin-top: 50px;
}

.mr-0 {
  margin-right: 0px;
}

.mr-3 {
  margin-right: 3px;
}

.mr-5 {
  margin-right: 5px;
}

.mr-10 {
  margin-right: 10px;
}

.mr-15 {
  margin-right: 15px;
}

.mr-20 {
  margin-right: 20px;
}

.mr-25 {
  margin-right: 25px;
}

.mr-30 {
  margin-right: 30px;
}

.mr-35 {
  margin-right: 35px;
}

.mr-40 {
  margin-right: 40px;
}

.mr-45 {
  margin-right: 45px;
}

.mr-50 {
  margin-right: 50px;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-3 {
  margin-bottom: 3px;
}

.mb-5 {
  margin-bottom: 5px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-25 {
  margin-bottom: 25px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-35 {
  margin-bottom: 35px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-45 {
  margin-bottom: 45px;
}

.mb-50 {
  margin-bottom: 50px;
}

.ml-0 {
  margin-left: 0px;
}

.ml-3 {
  margin-left: 3px;
}

.ml-5 {
  margin-left: 5px;
}

.ml-10 {
  margin-left: 10px;
}

.ml-15 {
  margin-left: 15px;
}

.ml-20 {
  margin-left: 20px;
}

.ml-25 {
  margin-left: 25px;
}

.ml-30 {
  margin-left: 30px;
}

.ml-35 {
  margin-left: 35px;
}

.ml-40 {
  margin-left: 40px;
}

.ml-45 {
  margin-left: 45px;
}

.ml-50 {
  margin-left: 50px;
}

.fade-enter-active, .fade-leave-active {
  transition: all .5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(1000px);
}

.scale-enter-active, .scale-leave-active {
  transition: all .5s ease;
}
.scale-enter, .scale-leave-to {
  opacity: 0;
  transform: scale(0);
}


</style>
